<template>
  <LayoutTemplate>
    <MainContainer is="main">
      <router-view />
    </MainContainer>
  </LayoutTemplate>
</template>
